import React, { useRef, useState, useEffect } from "react";

import Modal from "react-bootstrap/Modal";
import { Input } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";

import {
  useDisclosure,
  Textarea

} from "@chakra-ui/react";
import { Avatar, AvatarBadge, AvatarGroup } from '@chakra-ui/react'

import { useToast } from '@chakra-ui/react'

import CommentBox from "../commentBox/commentBox";


import PerfomerEdit from "../perfomerEdit/perfomerEdit";
import { useSelector } from "react-redux";
import axios from "axios";
import UploadFileTaskMenegerEditChilds from "../uploadFile/uploadFileChildEdit";
import StatusEdit from "../status/statusEdit";
import MetkaEdit from "../metka/editMetka";
import EditStatus from "../tableTask/editStatus/editStatus";
import DropdownMobileStatus from "../tableTask/EditStatusForMobile/editStatusForMobile";
import DropdownMobilePioritet from "../tableTask/editPrioritetForMobile/editPrioritetForMobile";
import Prioritet from "../prioritet/prioritet";
import Status from "../status/status";
import sockets from "../../../../socket/socket";


const socket = sockets


function ChilMNodalEdit({ item, allaray, nameCurrentSubTask, sendServer, load, editAllTask, index, allitem, handleGetNotify, handleClose, update, deleteItemByIndex }) {

  const toast = useToast()
  const getmyinfo = useSelector((allWorkers) => allWorkers);

  const [show, setShow] = useState(false);
  const handleCloseChild = () => setShow(false);
  const handleShow = () => setShow(true);
  const [comments, setComments] = useState([]);

  const currentDate = new Date();
  const adjustedDate = new Date(currentDate.getTime() - currentDate.getTimezoneOffset() * 60000);
  const formattedDate = adjustedDate.toISOString().slice(0, 16);
  const [startDate, setStartDate] = useState(formattedDate);
  const [endDate, setEndDate] = useState(formattedDate);
  const [status, setStatus] = useState("Запланирована");

  const [prioritet, setPrioritet] = useState("Низший");
  const [metka, setMetka] = useState([]);
  const [performer, setperformer] = useState("");
  const [aboutTask, setAboutTask] = useState("");
  const [file, setfile] = useState("");
  const [perfomerID, setperfomerID] = useState([]);
  const [endDateConfirm, setDndDateConfirm] = useState("");
  const modalRef = useRef(null);
  const gerChekcedCompany = useSelector((allWorkers) => allWorkers);

  // update for change child
  // добавляет состояние и отправлять
  // useEffect(()=>{
  //     console.log(item,"item" );
  //     console.log(allaray,"allaray");
  //     console.log(editAllTask,"editAllTask");
  //     console.log(allitem,"allitem");
  // },[allitem])

  useEffect(() => {
    modalRef.current.style.display = "none"
  }, [])


  useEffect(() => {


    setComments(item.comments)
    setStartDate(item.startDate)
    setEndDate(item.endDate)
    setAboutTask(item.aboutTask)
    setPrioritet(item.prioritet)
    setStatus(item.status)
    setperformer(item.performer)
    setfile(item.file)
    setMetka(item.metka)


  }, [item.comments, item.startDate, item.endDate, item.aboutTask, item.prioritet, item.status, item.performer, item.file, item.metka])






  // добавляет состояние и отправлять на сервер

  const sendserver = () => {
    item.comments = comments
    item.performer = performer
    item.startDate = startDate
    item.endDate = endDate
    item.status = status
    item.prioritet = prioritet
    item.aboutTask = aboutTask
    item.file = file
    item.metka = metka
    sendSeverCreatNotifyForTask()
    if (performer.email) {
      console.log(performer.email);
      axios.post('/sendEmail/api', {
        perfomerEmail: performer.email
      })
        .then(function (response) {
          console.log(response);
         
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    sendServer()
    // handleClose()
    // handleCloseChild()
  }

  // обрабатывать добавить исполнителя 
  const HandleSetPerfomerId = (e) => {

    setperfomerID([e])
    setperformer(e)
    item.performer = performer
    if (allaray[0]?.performer) {
      allaray[0].child[index].performer = e
    }
  }

  // обработать удалить Исполнитель 
  const HandleDeletePerfomerId = (e) => {
    setperformer("")
    setperfomerID([])
    item.performer = []


  }
  // этот функция отправляет для подтверждения дату

  const handleDate = () => {

    axios.post('/notifyConfirm', {
      eidtTaskID: allitem._id,
      isChild: true,
      adminIDTask: allitem.creatorTasks.toString(),
      typenotify: "date",
      indexTask: index,
      senderName: getmyinfo.getMayInfoReducer.myinfo.name,
      senderTel: getmyinfo.getMayInfoReducer.myinfo.tel,
      senderEmail: getmyinfo.getMayInfoReducer.myinfo.email,
      text: "",
      messageConfirm: endDateConfirm,
      taskName: nameCurrentSubTask,
      oldDate: editAllTask[0].child[index].endDate

    })
      .then(function (response) {
        console.log(response);
        handleGetNotify()
        toast({
          position: "top",
          title: 'Отправлено на подтверждение постановщику задачи',
          description: "Отправлено на подтверждение постановщику задачи",
          status: 'success',
          duration: 9000,
          isClosable: true,
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  // этот функция отправляет для подтверждения статус 
  const handleStatus = () => {
    axios.post('/notifyConfirm', {
      eidtTaskID: allitem._id,
      isChild: true,
      adminIDTask: allitem.creatorTasks.toString(),
      typenotify: "status",
      indexTask: index,
      senderName: getmyinfo.getMayInfoReducer.myinfo.name,
      senderTel: getmyinfo.getMayInfoReducer.myinfo.tel,
      senderEmail: getmyinfo.getMayInfoReducer.myinfo.email,
      text: "",
      messageConfirm: endDate,
      taskName: nameCurrentSubTask,
      oldDate: editAllTask[0].child[index].endDate

    })
      .then(function (response) {
        console.log(response);
        handleGetNotify()
        toast({
          position: "top",
          title: 'Отправлено на подтверждение постановщику задачи',
          description: "Отправлено на подтверждение постановщику задачи",
          status: 'success',
          duration: 9000,
          isClosable: true,
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  // обрабатывать файл изменений
  const handleChangeFile = (e) => {

    setfile(e)
    console.log(file);
  }

  const handleShowChildModal = () => {
    modalRef.current.style.display = "flex"
  }


  const handleCloseChildModal = () => {
    modalRef.current.style.display = "none"
  }
  useEffect(() => {


    if (performer == "") {
      if (allaray[0]?.performer) {
        setperformer(allaray[0]?.performer)

      }

    }
  }, [])


  async function sendSeverCreatNotifyForTask(e) {
    const taskID = await axios.get(`/findTaskById/api?taskID=${allitem._id}`);
      console.log(new Date(taskID.data.data.alltask[0].child[index].endDate).getTime(),new Date(allitem.alltask[0].endDate).getTime());
            if (taskID.data.data) {
              if (new Date(taskID.data.data.alltask[0].child[index].endDate).getTime() != new Date(endDate).getTime()) {
                if (allitem.alltask[0].performer) {
                  // получаем информацию о пользователе
                  const userInfo = await axios.get(`/getuserByID/api?userID=${allitem.creatorTasks}`);
                  let mount = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"];
                  const covertDate = new Date(endDate).getDay() + " "+ mount[new Date(endDate).getMonth()] + " " + new Date(endDate).getFullYear()
                  let notifyText = `${userInfo.data.data.name} изменил срок окончания <a target="_blank" class="taskName" href="editChild/${allitem._id}/${index}">${allitem.alltask[0].taskName}</a> на ${covertDate}  конца.`
                  axios.post('/creatNotifyForTaskInfo/api', {
                      // здесь не проверяем Это задача и подзадача
                      isChild:true,
                      // здесь мы отправляем полное задание
                      task:allitem,
                      //  // если это подзадача тогда получаем индекс этого подзадачу
                      index,
                       // здесь мы отправляем текст для уведомлений
                      notifyText,
                      // кому нужно отправить этот уведомление мы берём идентификатор этого пользователя
                      notificationRecipientID:allitem.alltask[0].child[index].performer.workerID,
                      // информация пользователя для отправления уведомлений на электронную почту
                      emailInfo:{
                          // здесь мы отправляем идентификатор пользователя
                          userIdForEmail:allitem.alltask[0].child[index].performer.workerID,
                          // текст для заголовки
                          subject:"Смена срока окончания задачи",
                          // текст для электронную почту
                          textEmail:`${userInfo.data.data.name} изменил срок окончания <a target="_blank" class="taskName" href="https://xn--h1alceggc.xn--p1ai/editChild/${allitem._id}/${index}">${allitem.alltask[0].taskName}</a> на ${covertDate}  конца.`
                      }
                  })
                  .then(function (response) {
                      console.log(response);
                      socket.emit('getNotifyEmit');
                  })
                  .catch(function (error) {
                      console.log(error);
                  });
                }
              }
            }
    
   
 

}


  return (
    <div className="modalCreatTaskChild">

      <div className="modalDateAndInfiOut">
        <div className="taskNameDateInfo">
          <h6>#{index + 1}</h6>
          <p className="TaskNameShow">{item.msg}</p>
          <p className="endDateChild">{endDate.split("T").join(",")}</p>
        </div>
        <div className="statusPrioritetChild">
          <div>
            {
              prioritet ?
                <DropdownMobilePioritet isChild={true} prioritetGet={prioritet} allitemForStatus={allitem} index={index} update={update} />
                :
                <Prioritet setPrioritet={setPrioritet} prioritet={prioritet} />
            }
            {(() => {
              let findWorkerID = gerChekcedCompany.rootReducer?.users?.data.find(findWorkerById => findWorkerById.workerID == item?.performer?.workerID);

              if (findWorkerID) {
                return <Avatar src={findWorkerID.img ? findWorkerID.img : "https://bit.ly/broken-link"} size={"sm"} />;
              } else {
                if (performer) {
                  return <Avatar src={performer.img ? performer.img : "https://bit.ly/broken-link"} size={"sm"} />;
                } else {
                  return null;
                }
                // You might want to return something in case findWorkerID is not truthy.
                // You can return null or an empty fragment as a placeholder.

              }
            })()}

            {
              status ?
                <DropdownMobileStatus isChild={true} statusGet={status} allitemForStatus={allitem} index={index} update={update} />
                :
                <Status setStatus={setStatus} status={status} />
            }
          </div>
          <div className="smollItem">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" onClick={handleShowChildModal} className="editSvgSubTask">
              <path d="M7.54953 4.2742L8.17752 4.9274L1.99318 11.36H1.3652V10.7068L7.54953 4.2742ZM10.0069 0C9.83623 0 9.65876 0.071 9.52906 0.2059L8.27991 1.5052L10.8396 4.1677L12.0888 2.8684C12.355 2.5915 12.355 2.1442 12.0888 1.8673L10.4915 0.2059C10.355 0.0639 10.1844 0 10.0069 0ZM7.54953 2.2649L0 10.1175V12.78H2.55974L10.1093 4.9274L7.54953 2.2649Z" fill="#3B79F6" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none" className="copyLinkSubTask">
              <path d="M9.59222 8.13283C9.22676 8.13369 8.86669 8.22096 8.54141 8.38754C8.21613 8.55412 7.93486 8.79527 7.72057 9.09131L4.80738 7.14938C4.99096 6.65987 4.99096 6.12042 4.80738 5.63092L7.72057 3.68898C8.04755 4.13228 8.5219 4.44445 9.05839 4.5694C9.59488 4.69435 10.1583 4.6239 10.6475 4.3707C11.1367 4.11749 11.5196 3.69813 11.7274 3.18797C11.9352 2.67781 11.9542 2.11027 11.7811 1.58734C11.6079 1.0644 11.254 0.620345 10.7829 0.334942C10.3117 0.0495394 9.75423 -0.0584985 9.21058 0.030239C8.66692 0.118976 8.17273 0.398672 7.81679 0.819076C7.46085 1.23948 7.26649 1.77303 7.26863 2.32388C7.2724 2.40852 7.28093 2.49288 7.29419 2.57657L4.16258 4.66431C3.82885 4.36345 3.41505 4.16582 2.97129 4.09533C2.52753 4.02485 2.07285 4.08453 1.66233 4.26717C1.2518 4.4498 0.903026 4.74755 0.658252 5.12434C0.413479 5.50114 0.283203 5.94082 0.283203 6.39015C0.283203 6.83947 0.413479 7.27915 0.658252 7.65595C0.903026 8.03274 1.2518 8.33049 1.66233 8.51312C2.07285 8.69576 2.52753 8.75545 2.97129 8.68496C3.41505 8.61448 3.82885 8.41684 4.16258 8.11599L7.29419 10.2037C7.28093 10.2874 7.2724 10.3718 7.26863 10.4564C7.26863 10.916 7.40491 11.3652 7.66023 11.7473C7.91555 12.1294 8.27844 12.4273 8.70302 12.6031C9.1276 12.779 9.59479 12.825 10.0455 12.7354C10.4963 12.6457 10.9103 12.4244 11.2352 12.0994C11.5602 11.7745 11.7815 11.3605 11.8712 10.9097C11.9608 10.459 11.9148 9.9918 11.7389 9.56722C11.5631 9.14264 11.2652 8.77975 10.8831 8.52443C10.501 8.26911 10.0518 8.13283 9.59222 8.13283Z" fill="#6B7A99" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none" className="deletSubTASK" onClick={() => deleteItemByIndex(index)}>
              <path d="M3.08594 13.2509C2.73145 13.2509 2.42798 13.1466 2.17554 12.9379C1.9231 12.7293 1.79688 12.4785 1.79688 12.1855V2.06481H0.916016V0.999467H4.95508V0.466797H10.627V0.999467H14.666V2.06481H13.7852V12.1855C13.7852 12.4696 13.6562 12.7182 13.3984 12.9313C13.1406 13.1444 12.8398 13.2509 12.4961 13.2509H3.08594ZM12.4961 2.06481H3.08594V12.1855H12.4961V2.06481ZM5.36328 10.6586H6.65234V3.57404H5.36328V10.6586ZM8.92969 10.6586H10.2187V3.57404H8.92969V10.6586Z" fill="#E62E7B" />
            </svg>
          </div>
        </div>


        <div id="myModal" class="modalChildModal" ref={modalRef} >
          <div class="modal-contentChildModal">
            <div className="modal-headerChildModal">
              <span class="closeChildModal" onClick={handleCloseChildModal}>&times;</span>
            </div>
            <div className="modal-bodyChildModal" style={{ flexDirection: "column" }}>
              <div className="perfomerAndShef">
                <div>
                  <PerfomerEdit performerS={performer} setperformerS={setperformer} HandleSetPerfomerId={HandleSetPerfomerId} HandleDeletePerfomerId={HandleDeletePerfomerId} />
                </div>
                <div className="iconSubTaskList">
                  <div style={{ margin: "10px" }}>
                    <div style={{ margin: "10px" }}>
                      {
                        prioritet ?
                          <DropdownMobilePioritet isChild={true} prioritetGet={prioritet} allitemForStatus={allitem} index={index} update={update} />
                          :
                          <Prioritet setPrioritet={setPrioritet} prioritet={prioritet} />
                      }
                    </div>





                    <div style={{ margin: "10px" }}>
                      {
                        status ?
                          <DropdownMobileStatus isChild={true} statusGet={status} allitemForStatus={allitem} index={index} update={update} />
                          :
                          <Status setStatus={setStatus} status={status} />
                      }
                    </div>
                  </div>



                  <div >

                  </div>

                </div>
              </div>
              <div className="inputCreatTask">

                <div className="taskinputsDiv">
                  <MetkaEdit setMetka={setMetka} metka={metka} />
                  <p className="currentNameP">Название подзадачи</p>
                  <input className="currentTaskName" value={nameCurrentSubTask} disabled />
                  <div style={{ margin: "30px 0px" }}>
                    <p className="srok">Сроки</p>
                    {(() => {
                      if (allitem.creatorTasks === getmyinfo.getMayInfoReducer.myinfo._id) {
                        return (
                          <div className="date">
                            <label htmlFor="">
                              {/* Дата начала  для поставщика*/}
                              Дата начала:
                              <input
                                size="sm"
                                type="datetime-local"
                                colorScheme="grey"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}

                              />
                            </label>
                            <label htmlFor="">
                              {/* Дата окончания  для поставщика*/}
                              Дата конца:
                              <input
                                size="sm"
                                type="datetime-local"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                style={
                                  new Date() > new Date(endDate) ? { color: "red" } : {}
                                }
                              />

                            </label>
                          </div>
                        )
                      } else {
                        return (
                          <div className="date">
                            <label htmlFor="">
                              {/* Дата начала  для исполнителя*/}
                              Дата начала:
                              <input
                                size="sm"
                                type="datetime-local"
                                colorScheme="grey"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                disabled

                              />
                            </label>
                            <label htmlFor="">
                              {/* Дата окончания  для исполнителя*/}
                              Дата конца:
                              <input
                                size="sm"
                                type="datetime-local"
                                defaultValue={endDate}
                                onChange={(e) => setDndDateConfirm(e.target.value)}
                                key={endDate + endDateConfirm + item.endDate}
                                style={
                                  new Date() > new Date(endDate) ? { color: "red" } : {}
                                }
                              />
                              <button onClick={handleDate} className="confirmEditDate">Запросить подтверждение</button>
                            </label>
                          </div>
                        )
                      }
                    })()}
                  </div>
                  <textarea placeholder='Добавьте  описание подзадачи' className="taskDeskription" value={aboutTask} onChange={(e) => setAboutTask(e.target.value)} />
                  <p className="taskDeskriptionText">Добавьте описание задачи</p>


                  {/* загрузить файл дочернего компонента */}
                  <UploadFileTaskMenegerEditChilds file={file} handleChangeFile={handleChangeFile} />


                </div>

                <div className="taskinputsDiv2">
                  {/* Компонент исполнителя */}



                  {/* компонент состояния */}
                  {/* <StatusEdit setStatus={setStatus} status={status} creatorTasks={allitem.creatorTasks}/> */}


                  {/* метка компонент */}
                  <CommentBox setComments={setComments} comments={comments} index={index} isChild={true} allitem={allitem} editAllTask={editAllTask} update={update} />
                </div>
              </div>
            </div>
            <div className="modal-footerChildModal">
              <button variant="secondary" onClick={handleCloseChildModal}>
                Закрыть
              </button>
              <button onClick={sendserver}>
                Сохранить
              </button>
            </div>
          </div>
        </div>
      </div>





    </div>
  );
}

export default ChilMNodalEdit;
